import React from 'react';
import { getData, deleteData, } from './core/HttpAction'; 
import {withRouter} from 'react-router-dom';
const Url='/statistics/library';
const columns=[
    {
        key:'type_name',
        displayName:'Staff Type'
    } 
];
  
class Landing extends React.Component {
    constructor(props) {
        super(props);
        this.state={ 
            data:[],
            preloader:true,
        };
        this.fetchData = this.fetchData.bind(this); 
    }
 
    componentDidMount(){
        this.fetchData();
    }

 
    fetchData(){
        getData(Url).then((res)=>{ 
            this.setState({data:res.data.data,preloader:false}); 
        });
    }

    render() {
        let {book_category_count,book_available_count,book_count,book_issed_count,magazine_total_count,journal_total_count}=this.state.data; 
        const totalWidth = 100;
        let width1 = book_available_count/book_count*totalWidth||0;
        width1 = width1 + '%';
        let width2 = book_issed_count/book_count*totalWidth||0;
        width2 = width2 + '%';

        let width4=book_category_count?'100%':'0%';
        let width3=book_count?'100%':'0%';

        return (
            <div id="page_content_inner">
  
                <div className="uk-width-medium-1-1">
                    <h2><b>Library</b></h2> 
                    <div className="uk-grid" style={{marginTop:'-15px'}}>
                        <div className="uk-width-large-1-4 uk-margin-top">
                            <div className="md-card">
                                <div className="md-card-content">
                                    <h3>  <span className="leads_pending_graph">Total Category - </span><span className="done-lead"><b>{book_category_count}</b></span></h3>
                                    <div className="uk-progress  uk-progress-striped uk-progress-mini uk-progress-primary uk-margin-remove">
                                        <div className="uk-progress-bar" style={{width :width4}} ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="uk-width-large-1-4 uk-margin-top">
                            <div className="md-card">
                                <div className="md-card-content">
                                    <h3 className="leads_done_cls">
                                        <span className="leads_done_graph ">Total Books - </span>
                                        <span className="done-lead"><b>{book_count}</b></span>
                                    </h3>
                                    <div className="uk-progress uk-progress-mini uk-progress-striped uk-progress uk-progress-primary uk-margin-remove">
                                        <div className="uk-progress-bar" style={{width :width3}}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="uk-width-large-1-4 uk-margin-top">
                            <div className="md-card">
                                <div className="md-card-content">
                                    <h3 className="leads_pending_cls"> 
                                        <span className="leads_pending_graph">Issued Books - </span>
                                        <span className="pending-lead"><b>{book_issed_count}</b></span> 
                                    </h3>
                                    <div className="uk-progress  uk-progress-striped uk-progress-mini uk-progress-danger uk-margin-remove">
                                        <div className="uk-progress-bar" style={{width : width2}} ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="uk-width-large-1-4 uk-margin-top">
                            <div className="md-card">
                                <div className="md-card-content">
                                    <h3 className="leads_inprogress_cls">
                                        <span className="leads_inprogress_graph">Available Books - </span>
                                        <span className="inprogress-lead"><b>{book_available_count}</b></span>
                                    </h3>
                                    <div className="uk-progress uk-progress-striped uk-progress-mini uk-progress-success uk-margin-remove">
                                        <div className="uk-progress-bar" style={{width :width1}}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="uk-width-large-1-4 uk-margin-top">
                            <div className="md-card">
                                <div className="md-card-content">
                                    <h3>  <span className="leads_pending_graph">Total Magazines - </span><span className="done-lead"><b>{magazine_total_count}</b></span></h3>
                                    <div className="uk-progress  uk-progress-striped uk-progress-mini uk-progress-primary uk-margin-remove">
                                        <div className="uk-progress-bar" style={{width :width4}} ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="uk-width-large-1-4 uk-margin-top">
                            <div className="md-card">
                                <div className="md-card-content">
                                    <h3>  <span className="leads_pending_graph">Total Journals  - </span><span className="done-lead"><b>{journal_total_count}</b></span></h3>
                                    <div className="uk-progress  uk-progress-striped uk-progress-mini uk-progress-primary uk-margin-remove">
                                        <div className="uk-progress-bar" style={{width :width4}} ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                            
                    </div>            
                </div>
                <br/> 

                <div className="md-card">
                    <div className="md-card-content">
                        <div className="uk-width-1-1" style={{padding: '0% 10% 0% 10%' }}> 
                            <div className="uk-slidenav-position" data-uk-slideshow="{autoplay:true,kenburns:true}">
                                <ul className="uk-slideshow" style={{height: '200px' }}>
                                    <li><img  height='200px' src={`${window.publicUrl}/assets/img/gallery/theni_3.jpg`} alt=""/></li>
                                </ul>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
 
export default  withRouter(Landing); 




 



// WEBPACK FOOTER //
// ./src/Landing.js